import { InjectionToken, Directive, TemplateRef, ViewContainerRef, ChangeDetectorRef, Input, Optional, Inject, ContentChildren, NgModule } from '@angular/core';
import { maybe } from 'typescript-monads';
import { debounceTime, map, takeUntil, flatMap, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const LOADERS = new InjectionToken('fs.ff.loaders');
/** @type {?} */
const FS_FETCH_FILL_DEBOUNCE = new InjectionToken('fs.ff.debounce');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable: readonly-keyword
// tslint:disable: no-object-mutation
/**
 * @template TInItem, TOutItem
 */
class FloFetchFillItemDirective {
    /**
     * @param {?} tr
     * @param {?} vc
     * @param {?} cd
     */
    constructor(tr, vc, cd) {
        this.tr = tr;
        this.vc = vc;
        this.cd = cd;
    }
    /**
     * @return {?}
     */
    get outputKey() {
        return this._outputKey;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set outputKey(val) {
        this._outputKey = maybe(val).map((/**
         * @param {?} a
         * @return {?}
         */
        a => a.toString())).valueOrUndefined();
    }
    /**
     * @param {?} res
     * @return {?}
     */
    setResponse(res) {
        if (res.isOk()) {
            this.vc.createEmbeddedView(this.tr, {
                $implicit: res.unwrap()
            });
        }
        else {
            this.vc.clear();
        }
        this.cd.detectChanges();
    }
}
FloFetchFillItemDirective.ɵfac = function FloFetchFillItemDirective_Factory(t) { return new (t || FloFetchFillItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FloFetchFillItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloFetchFillItemDirective, selectors: [["", "floFetchFillItem", ""]], inputs: { outputKey: ["floFetchFillItemUsingOutputKey", "outputKey"], input: ["floFetchFillItemOf", "input"] } });
/** @nocollapse */
FloFetchFillItemDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ChangeDetectorRef }
];
FloFetchFillItemDirective.propDecorators = {
    input: [{ type: Input, args: ['floFetchFillItemOf',] }],
    outputKey: [{ type: Input, args: ['floFetchFillItemUsingOutputKey',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloFetchFillItemDirective, [{
        type: Directive,
        args: [{
                selector: '[floFetchFillItem]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { outputKey: [{
            type: Input,
            args: ['floFetchFillItemUsingOutputKey']
        }], input: [{
            type: Input,
            args: ['floFetchFillItemOf']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template TInItem, TOutItem, TInError, TOutError
 */
class FloFetchFillDirective {
    /**
     * @param {?} _loaders
     * @param {?} _debounceTime
     */
    constructor(_loaders, _debounceTime) {
        this._loaders = _loaders;
        this._debounceTime = _debounceTime;
        this.ngOnDestroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    get loaders() {
        return this._loaders || [];
    }
    /**
     * @return {?}
     */
    get debounceTime() {
        return this._debounceTime;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set debounceTime(val) {
        this._debounceTime = typeof val === 'number' ? val : this._debounceTime;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        /** @type {?} */
        const loader = this.loaders.find((/**
         * @param {?} b
         * @return {?}
         */
        b => b.key === this.floFetchFill));
        if (!loader) {
            return;
        }
        this.fillItems.changes.pipe(debounceTime(this.debounceTime), map((/**
         * @param {?} a
         * @return {?}
         */
        (a) => a.toArray())), takeUntil(this.ngOnDestroy$), flatMap((/**
         * @param {?} items
         * @return {?}
         */
        items => loader.func(items.map((/**
         * @param {?} a
         * @return {?}
         */
        a => a.input))).pipe(filter((/**
         * @param {?} b
         * @return {?}
         */
        b => b.isOk())), map((/**
         * @param {?} b
         * @return {?}
         */
        b => b.unwrap()))))), map((/**
         * @param {?} results
         * @return {?}
         */
        results => Object
            .keys(results)
            .reduce((/**
         * @param {?} acc
         * @param {?} key
         * @return {?}
         */
        (acc, key) => {
            /** @type {?} */
            const directive = this.fillItems.find((/**
             * @param {?} a
             * @return {?}
             */
            a => a.outputKey === key));
            return directive ? [...acc, { directive, item: results[key] }] : acc;
        }), []))))
            .subscribe((/**
         * @param {?} results
         * @return {?}
         */
        results => {
            results.forEach((/**
             * @param {?} r
             * @return {?}
             */
            r => r.directive.setResponse(r.item)));
        }));
        this.fillItems.notifyOnChanges();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
FloFetchFillDirective.ɵfac = function FloFetchFillDirective_Factory(t) { return new (t || FloFetchFillDirective)(ɵngcc0.ɵɵdirectiveInject(LOADERS, 8), ɵngcc0.ɵɵdirectiveInject(FS_FETCH_FILL_DEBOUNCE)); };
FloFetchFillDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloFetchFillDirective, selectors: [["", "floFetchFill", ""]], contentQueries: function FloFetchFillDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloFetchFillItemDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fillItems = _t);
    } }, inputs: { debounceTime: "debounceTime", floFetchFill: "floFetchFill" } });
/** @nocollapse */
FloFetchFillDirective.ctorParameters = () => [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [LOADERS,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FS_FETCH_FILL_DEBOUNCE,] }] }
];
FloFetchFillDirective.propDecorators = {
    debounceTime: [{ type: Input }],
    floFetchFill: [{ type: Input }],
    fillItems: [{ type: ContentChildren, args: [FloFetchFillItemDirective, { descendants: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloFetchFillDirective, [{
        type: Directive,
        args: [{
                selector: '[floFetchFill]'
            }]
    }], function () { return [{ type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [LOADERS]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FS_FETCH_FILL_DEBOUNCE]
            }] }]; }, { debounceTime: [{
            type: Input
        }], floFetchFill: [{
            type: Input
        }], fillItems: [{
            type: ContentChildren,
            args: [FloFetchFillItemDirective, { descendants: true }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FloFetchFillModule {
}
FloFetchFillModule.ɵfac = function FloFetchFillModule_Factory(t) { return new (t || FloFetchFillModule)(); };
FloFetchFillModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FloFetchFillModule });
FloFetchFillModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: FS_FETCH_FILL_DEBOUNCE, useValue: 200 }
    ], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloFetchFillModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    FloFetchFillDirective,
                    FloFetchFillItemDirective
                ],
                exports: [
                    FloFetchFillDirective,
                    FloFetchFillItemDirective
                ],
                providers: [
                    { provide: FS_FETCH_FILL_DEBOUNCE, useValue: 200 }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FloFetchFillModule, { declarations: function () { return [FloFetchFillDirective, FloFetchFillItemDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FloFetchFillDirective, FloFetchFillItemDirective]; } }); })();

export { FS_FETCH_FILL_DEBOUNCE, FloFetchFillDirective, FloFetchFillModule, LOADERS, FloFetchFillItemDirective as ɵa };

